import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#clip0_6700_21102)" }, [
      _createElementVNode("path", {
        fill: "currentColor",
        d: "M8.414 3.336q.095.163.162.34c.924-.491 1.944-.556 2.832-.215 1.42.547 2.304 2.055 1.915 4.003a.667.667 0 0 1-.901.489l-3.15-1.26c.424 1.512.467 3.052.396 4.263-.052.852-.17 1.7-.351 2.533a.68.68 0 0 1-.648.511H7.002a.666.666 0 0 1-.596-.964c.302-.607.502-1.28.656-1.937.253-1.086.397-2.467.072-3.854l-3.612 2.32a.667.667 0 0 1-1.02-.468c-.25-1.796.478-3.394 1.714-4.235q.084-.058.173-.111l-1.277-.456a.667.667 0 0 1-.248-1.1C4.033 2.027 5.628 1.7 6.88 2.117c.63.211 1.191.618 1.534 1.219"
      })
    ], -1)
  ])))
}
export default { render: render }